module.exports = __webpack_public_path__ + "img/dab_fernite.486441f9.jpg";